import React, { useState } from 'react';
import { Building2, Loader2, AlertCircle } from 'lucide-react';
import { useAuth } from '../../contexts';
import { createFirstCompany } from '../../lib/invitations';

const CreateCompanyModal = ({ onClose, onCompanyCreated }) => {
  const { user } = useAuth();
  const [companyName, setCompanyName] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async () => {
    if (!companyName.trim()) {
      setError('Veuillez entrer un nom d\'entreprise');
      return;
    }
    setIsCreating(true);
    try {
      const companyId = await createFirstCompany(user.uid, companyName);
      setCompanyName('');
      setError('');
      onCompanyCreated(companyId);
    } catch (e) {
      console.error(e);
      setError('Erreur lors de la création. Veuillez réessayer.');
      setIsCreating(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all scale-100">
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6 text-white">
          <h3 className="font-bold text-xl flex items-center gap-2">
            <Building2 size={24} /> Créer une Entreprise
          </h3>
          <p className="text-blue-100 text-sm mt-1">Donnez un nom à votre première entreprise.</p>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="text-xs font-bold text-slate-600 uppercase mb-2 block">Nom de l'entreprise</label>
            <input
              type="text"
              className="w-full border border-slate-200 bg-slate-50 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 transition font-medium text-slate-700"
              placeholder="Ex: Ovrio SARL"
              value={companyName}
              onChange={(e) => { setCompanyName(e.target.value); setError(''); }}
              onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
              autoFocus
              disabled={isCreating}
            />
          </div>
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-sm text-red-700">
              <AlertCircle size={16} /> {error}
            </div>
          )}
          <div className="flex justify-end gap-3 pt-2">
            {onClose && (
              <button onClick={onClose} disabled={isCreating} className="px-5 py-2.5 rounded-xl font-bold text-slate-600 hover:bg-slate-100 transition disabled:opacity-50">
                Annuler
              </button>
            )}
            <button
              onClick={handleCreate}
              disabled={!companyName.trim() || isCreating}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isCreating ? <><Loader2 size={18} className="animate-spin" /> Création...</> : <>Créer</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyModal;
